import { useState, useEffect } from 'react';
import { Bank } from '../apiTypes';
import { fetchBankById } from '../functionApi';
import { useAxiosInterceptor } from '../wrappers';

export function useBank(bankId?: string) {
  useAxiosInterceptor();
  const [bank, setBank] = useState<Bank | undefined>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!bankId) return;

    const loadBank = async () => {
      setLoading(true);
      try {
        const data = await fetchBankById(bankId);
        setBank(data);
        setError(null);
    //    console.log('✅ Bank data:', data);
      } catch (err) {
        setError('Errore caricamento banca');
        console.error('❌ Errore caricamento banca:', err);
      } finally {
        setLoading(false);
      }
    };

    loadBank();
  }, [bankId]);

  return { bank, loading, error };
}
